import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE, IMG } from "../../lib/site";
import { Overline, Reveal } from "./Reveal";
import QuoteForm from "./QuoteForm";

export function PageHero({ overline, title, subtitle }) {
  return (
    <section className="px-6 md:px-10 lg:px-16 pt-10 md:pt-16 pb-14 md:pb-20 border-b border-white/10">
      <Reveal>
        {overline && <Overline>{overline}</Overline>}
        <h1 className="font-head font-black uppercase tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5 max-w-4xl">{title}</h1>
        {subtitle && <p className="text-base md:text-lg text-[#8A8A9B] mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
      </Reveal>
    </section>
  );
}

export function CtaBand({ sourcePage = "/" }) {
  return (
    <section className="relative border-t border-white/10 overflow-hidden">
      <img src={IMG.ctaBg} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover opacity-30" loading="lazy" />
      <div className="relative px-6 md:px-10 lg:px-16 py-20 md:py-28 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <Overline>Get a Quote</Overline>
          <h2 className="font-head text-3xl md:text-4xl font-bold tracking-tight mt-4">Request a free hologram sticker quote.</h2>
          <p className="text-[#8A8A9B] mt-5 max-w-md">Share your requirements and our UAE-based team will get back to you shortly.</p>
          <div className="mt-8 flex flex-col gap-2 font-mono2 text-sm">
            <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="link-arrow">Chat on WhatsApp <span>&rarr;</span></a>
            <a href={`tel:${SITE.phoneRaw}`} className="link-arrow">Call {SITE.phone} <span>&rarr;</span></a>
          </div>
        </Reveal>
        <Reveal delay={0.1}><QuoteForm sourcePage={sourcePage} compact /></Reveal>
      </div>
    </section>
  );
}

export function RelatedGrid({ title, items }) {
  return (
    <section className="px-6 md:px-10 lg:px-16 py-20 border-t border-white/10">
      <Overline>{title}</Overline>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
        {items.map((it, i) => (
          <Link key={i} to={it.to} className="card p-6 block group" data-testid={`related-${i}`}>
            <h3 className="font-head text-base font-semibold group-hover:text-holo-cyan transition-colors flex items-center justify-between">{it.name} <ArrowRight size={15} /></h3>
            {it.desc && <p className="text-xs text-[#8A8A9B] mt-2 leading-relaxed">{it.desc}</p>}
          </Link>
        ))}
      </div>
    </section>
  );
}
